// extracted by mini-css-extract-plugin
export default {"root":"style_root__1W5g6","ldsRing":"style_ldsRing__jJL+e","ldsRingItem":"style_ldsRingItem__YubtL","lds-ring":"style_lds-ring__KJtic"};